import React, { FC } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import Modal, { ModalSize } from 'components/modal';
import ModalContent from 'components/modal/modal-content';
import ModalHeading from 'components/modal/modal-heading';
import { IUseDialogComponentProps } from 'hooks/use-dialog-modal';

import { AcceptModalBody } from './accept-modal-body';
import { DeclineModalBody, SelectionValue } from './decline-modal-body';

const ModalWrapper = styled(Modal)`
  border-radius: ${Styles.borderRadius};
  min-width: 450px;
  && {
    overflow-y: visible;
  }
  & h2[class*='modal-heading'] {
    font-size: 22px;
    line-height: 22px;
    margin: 32px 0 35px;
  }
`;
const ModalContentWrapper = styled(ModalContent)`
  border-radius: ${Styles.borderRadius};
  background: ${Styles.color.background};
  & div[class*='modal-scroller'] {
    overflow: visible;
  }
`;

export enum ModalType {
  ACCEPT,
  DECLINE,
}
declare interface ICateringConfirmationModal extends IUseDialogComponentProps {
  type: ModalType;
  pickupTime?: string;
  onDecline?: (reason: SelectionValue) => void;
}

export const CateringConfirmationModal: FC<ICateringConfirmationModal> = ({
  onDismiss,
  onDecline,
  onConfirm,
  type,
  pickupTime,
}) => {
  const { formatMessage } = useIntl();
  const isAccept = type === ModalType.ACCEPT;
  const modalHeading = formatMessage({ id: isAccept ? 'acceptOrder' : 'declineOrder' });
  const ModalBody = isAccept ? AcceptModalBody : DeclineModalBody;
  return (
    <ModalWrapper size={ModalSize.SMALL} allowsDismiss onDismiss={onDismiss}>
      <ModalContentWrapper>
        <ModalHeading>{modalHeading}</ModalHeading>
        <ModalBody
          onConfirm={onConfirm}
          pickupTime={pickupTime}
          onDecline={onDecline}
          onDismiss={onDismiss}
        />
      </ModalContentWrapper>
    </ModalWrapper>
  );
};
